import { Box, Modal } from "@mui/material";
import { ExternalLink, X } from "lucide-react";

/* Sample of the document being ordered, from the `sample` object on the
   document's entry in states/<state>/<mode>/index.json ({ url, type }).
   PDFs render in an iframe; mobile browsers that won't render PDFs inline
   (Android Chrome) still get the "Open in new tab" link. */
const SampleDocumentModal = ({ open, onClose, sample, documentName }) => {
  if (!sample?.url) return null;
  const isPdf = sample.type === "pdf" || /\.pdf($|\?)/i.test(sample.url);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="jd-sample-document-title"
      className="backdrop-blur-sm border-none"
    >
      <Box
        className="modal-center relative outline-none flex flex-col"
        sx={{
          height: "88vh",
          width: { xs: "94vw", md: "80vw", lg: "64vw" },
          maxWidth: "980px",
          borderRadius: "18px",
          border: "1px solid rgba(234,232,226,0.9)",
          background: "#ffffff",
          boxShadow: "0 28px 70px -30px rgba(13,31,53,0.42)",
          overflow: "hidden",
        }}
      >
        <div className="flex items-center justify-between gap-3 border-b border-[#d8e2ee] px-4 py-3 md:px-5">
          <h3
            id="jd-sample-document-title"
            className="min-w-0 truncate text-base font-bold text-[#153568] md:text-lg"
          >
            Sample {documentName || "Document"}
          </h3>
          <div className="flex shrink-0 items-center gap-2">
            <a
              href={sample.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 rounded-full border border-[#d8e2ee] px-3 py-1.5 text-[12.5px] font-semibold text-[#153568] no-underline hover:bg-[#fff5d9]"
            >
              <ExternalLink size={14} />
              <span className="hidden sm:inline">Open in new tab</span>
            </a>
            <button
              type="button"
              aria-label="Close sample"
              onClick={onClose}
              className="grid h-9 w-9 cursor-pointer place-items-center rounded-full border border-[#d8e2ee] bg-white hover:bg-[#fff5d9] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#ffa900]"
            >
              <X size={18} color="#153568" />
            </button>
          </div>
        </div>

        <div className="min-h-0 flex-1 bg-[#f8f9fb] p-3 md:p-4">
          <div className="h-full w-full overflow-auto rounded-xl border border-[#e4e8ef] bg-white">
            {isPdf ? (
              <iframe
                src={sample.url}
                className="h-full w-full border-0"
                title={`Sample ${documentName || "document"}`}
              />
            ) : (
              <img
                src={sample.url}
                alt={`Sample ${documentName || "document"}`}
                className="mx-auto block h-auto max-w-full"
              />
            )}
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default SampleDocumentModal;
